<div class="grid grid-cols-12 my-20">
  <div class="col-start-2 col-span-10">
    <h1 class="self-stretch text-center justify-start text-gray-900 text-4xl font-extrabold font-['Inter'] leading-[54px]">
      Política de Privacidade - Casato Brasil
    </h1>
    <p class="text-center justify-start text-gray-500 text-xl font-normal font-['Inter'] leading-loose">
      Última atualização: 6 de maio de 2026
    </p>

    <div class="self-stretch justify-start mt-20 text-gray-500 text-base font-normal font-['Inter'] leading-normal">
      <section class="mt-6">
        <h2 class="font-bold">1. Introdução</h2>
        <p class="mt-1">
          A presente Política de Privacidade descreve como a Casato Brasil coleta, utiliza, armazena, compartilha e protege dados pessoais relacionados ao uso da plataforma Casato Brasil (“Plataforma”).
        </p>
        <p class="mt-1">
          Ao utilizar a Plataforma, criar uma conta ou contratar qualquer serviço disponibilizado, o usuário declara estar ciente desta Política.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">2. Identificação da Responsável pelo Tratamento</h2>
        <p class="mt-1">
          A plataforma Casato Brasil é operada por Muse Digital, responsável pela gestão comercial e operacional da marca Casato Brasil (“Casato”, “nós” ou “Controladora”).
        </p>
        <p class="mt-1">
          Durante o período de teste gratuito, a Casato poderá enviar comunicações relacionadas à ativação da conta, uso da Plataforma, orientações sobre funcionalidades, lembretes sobre o encerramento do período de teste e ofertas relacionadas aos seus serviços.
        </p>
        <p class="mt-1">
          Mediante consentimento do usuário, poderemos utilizar o e-mail fornecido para envio de comunicações promocionais, conteúdos e atualizações sobre a plataforma. O usuário pode optar por não receber tais comunicações a qualquer momento.
        </p>
        <p class="mt-1">
          O usuário poderá optar por não receber comunicações promocionais a qualquer momento, quando aplicável, sem prejuízo do envio de mensagens estritamente necessárias à operação da conta ou do serviço.
        </p>
        <p class="mt-1">Para assuntos relacionados à privacidade:</p>
        <p class="mt-1">
          <a href="mailto:contato&#64;casatobrasil.com.br" class="text-blue-600 hover:underline">contato&#64;casatobrasil.com.br</a>
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">3. Dados Pessoais Coletados</h2>
        <p class="mt-1">Poderemos coletar apenas os dados necessários para funcionamento da Plataforma.</p>

        <h3 class="mt-4 font-bold">3.1 Dados fornecidos pelo usuário</h3>
        <ul class="mt-1 list-disc pl-6">
          <li>Nome</li>
          <li>Sobrenome</li>
          <li>Endereço de e-mail</li>
          <li>Cidade e estado</li>
          <li>Informações preenchidas no perfil da conta</li>
        </ul>

        <h3 class="mt-4 font-bold">3.2 Dados de conta e autenticação</h3>
        <ul class="mt-1 list-disc pl-6">
          <li>Login de acesso</li>
          <li>Identificadores internos da conta</li>
          <li>Registros de criação, alteração ou encerramento de conta</li>
        </ul>

        <h3 class="mt-4 font-bold">3.3 Dados técnicos</h3>
        <ul class="mt-1 list-disc pl-6">
          <li>Endereço IP</li>
          <li>Navegador utilizado</li>
          <li>Tipo de dispositivo</li>
          <li>Sistema operacional</li>
          <li>Data e hora de acesso</li>
          <li>Logs técnicos e registros de segurança</li>
          <li>Registros voltados à prevenção de fraude, auditoria interna e uso indevido da Plataforma</li>
        </ul>

        <h3 class="mt-4 font-bold">3.4 Dados de assinatura</h3>
        <ul class="mt-1 list-disc pl-6">
          <li>Plano contratado</li>
          <li>Situação da assinatura</li>
          <li>Período de teste gratuito</li>
          <li>Datas de renovação, cancelamento e expiração</li>
        </ul>

        <h3 class="mt-4 font-bold">3.5 Dados de pagamento</h3>
        <p class="mt-1">
          Pagamentos e assinaturas poderão ser processados por Stripe ou provedores equivalentes.
        </p>
        <p class="mt-1">
          A Casato não armazena diretamente dados completos de cartão de crédito ou credenciais financeiras sensíveis.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">4. Uso de Fornecedores Especializados</h2>
        <p class="mt-1">
          Para viabilizar a operação da Plataforma, parte do processamento e armazenamento de dados poderá ocorrer por meio de fornecedores especializados contratados pela Casato, incluindo:
        </p>
        <ul class="mt-1 list-disc pl-6">
          <li>Stripe, para pagamentos, cobranças e assinaturas</li>
          <li>Amazon Web Services, para hospedagem, infraestrutura e armazenamento técnico</li>
          <li>Serviços de autenticação e segurança</li>
          <li>Ferramentas estritamente necessárias ao funcionamento da Plataforma</li>
          <li>Prestadores jurídicos, contábeis ou operacionais, quando necessário</li>
        </ul>
        <p class="mt-1">
          Esses fornecedores poderão tratar dados pessoais conforme seus próprios termos, políticas e obrigações legais aplicáveis.
        </p>
        <p class="mt-1">
          A Casato busca utilizar parceiros reconhecidos no mercado e adota medidas razoáveis na seleção de fornecedores adequados.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">5. Minimização de Dados</h2>
        <p class="mt-1">
          Como regra geral, a Casato busca coletar apenas os dados mínimos necessários para operar a Plataforma.
        </p>
        <p class="mt-1">
          Grande parte do processamento técnico poderá ocorrer por meio de fornecedores especializados, limitando o acesso interno ao necessário para:
        </p>
        <ul class="mt-1 list-disc pl-6">
          <li>suporte ao usuário</li>
          <li>gestão de conta</li>
          <li>prevenção à fraude</li>
          <li>cobrança e assinaturas</li>
          <li>segurança da Plataforma</li>
          <li>auditoria interna</li>
          <li>cumprimento de obrigações legais</li>
        </ul>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">6. Finalidades do Tratamento</h2>
        <p class="mt-1">Os dados pessoais poderão ser utilizados para:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>Criar e administrar contas de usuário</li>
          <li>Permitir login e autenticação</li>
          <li>Processar assinaturas e pagamentos</li>
          <li>Gerenciar períodos de teste gratuito</li>
          <li>Enviar comunicações operacionais</li>
          <li>Enviar comunicações durante o período de teste gratuito</li>
          <li>Enviar comunicações promocionais, quando permitido por lei ou autorizado pelo usuário</li>
          <li>Enviar alertas solicitados pelo usuário</li>
          <li>Prestar suporte técnico e atendimento</li>
          <li>Detectar fraudes e abusos</li>
          <li>Melhorar estabilidade e segurança da Plataforma</li>
          <li>Realizar auditoria interna e prevenção de uso indevido</li>
          <li>Cumprir obrigações legais, regulatórias ou fiscais</li>
        </ul>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">7. Bases Legais Aplicáveis</h2>
        <p class="mt-1">Quando exigido por lei, o tratamento poderá ocorrer com fundamento em:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>Execução de contrato</li>
          <li>Cumprimento de obrigação legal</li>
          <li>Legítimo interesse</li>
          <li>Exercício regular de direitos</li>
          <li>Consentimento, quando necessário</li>
        </ul>
        <p class="mt-1">
          Comunicações operacionais relacionadas à conta ou ao serviço poderão ocorrer com base na execução do contrato ou legítimo interesse, conforme aplicável.
        </p>
        <p class="mt-1">
          Comunicações promocionais poderão ocorrer com base em consentimento ou legítimo interesse, quando permitido pela legislação aplicável.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">8. Dados Públicos e Processamento Automatizado</h2>
        <p class="mt-1">
          A Plataforma poderá consolidar informações públicas relacionadas a imóveis ofertados em leilões no Brasil.
        </p>
        <p class="mt-1">Essas informações podem ser estruturadas por meio de:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>Fontes públicas</li>
          <li>Informações de terceiros</li>
          <li>Processamento automatizado</li>
          <li>Recursos tecnológicos, incluindo inteligência artificial</li>
        </ul>
        <p class="mt-1">Tais funcionalidades possuem natureza informativa e estimativa.</p>
        <p class="mt-1">
          Informações públicas ou de terceiros poderão conter atrasos, inconsistências, alterações externas ou imprecisões.
        </p>
        <p class="mt-1">
          A Casato não realiza decisões automatizadas que produzam efeitos jurídicos relevantes sobre o usuário.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">9. Transferência Internacional de Dados</h2>
        <p class="mt-1">
          Os dados poderão ser processados ou armazenados fora do país do usuário, inclusive na União Europeia ou em outras jurisdições onde estejam localizados nossos fornecedores.
        </p>
        <p class="mt-1">
          Quando aplicável, adotaremos medidas razoáveis e mecanismos legalmente adequados para essas transferências.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">10. Retenção de Dados</h2>
        <p class="mt-1">Os dados pessoais poderão ser mantidos pelo período necessário para:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>Manutenção da conta ativa</li>
          <li>Prestação dos serviços contratados</li>
          <li>Cumprimento de obrigações legais ou fiscais</li>
          <li>Prevenção à fraude</li>
          <li>Resolução de disputas</li>
          <li>Exercício regular de direitos</li>
        </ul>
        <p class="mt-1">
          Após esse período, os dados poderão ser excluídos, anonimizados ou mantidos quando permitido por lei.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">11. Segurança da Informação</h2>
        <p class="mt-1">Adotamos medidas técnicas e organizacionais razoáveis para proteger dados pessoais contra:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>Acesso não autorizado</li>
          <li>Uso indevido</li>
          <li>Alteração indevida</li>
          <li>Perda acidental</li>
          <li>Divulgação indevida</li>
        </ul>
        <p class="mt-1">
          Nenhum sistema é totalmente invulnerável, mas buscamos padrões adequados de segurança compatíveis com a operação da Plataforma.
        </p>
        <p class="mt-1">
          Em caso de incidentes de segurança com potencial risco relevante aos titulares, a Casato poderá adotar as medidas cabíveis, incluindo comunicações exigidas pela legislação aplicável.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">12. Cookies e Tecnologias Semelhantes</h2>
        <p class="mt-1">A Plataforma utiliza apenas cookies e tecnologias estritamente necessários para:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>Login e autenticação</li>
          <li>Segurança da conta</li>
          <li>Processamento de pagamentos</li>
          <li>Funcionamento técnico da Plataforma</li>
          <li>Manutenção de sessão</li>
        </ul>
        <p class="mt-1">
          No momento, não utilizamos cookies de publicidade comportamental ou rastreamento invasivo.
        </p>
        <p class="mt-1">
          O usuário poderá configurar seu navegador para bloquear cookies, ciente de que determinadas funcionalidades poderão ser afetadas.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">13. Direitos do Titular</h2>
        <p class="mt-1">Quando previstos pela legislação aplicável, o usuário poderá solicitar:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>confirmação sobre tratamento de dados</li>
          <li>acesso aos dados pessoais</li>
          <li>correção de dados incompletos, inexatos ou desatualizados</li>
          <li>exclusão, anonimização ou bloqueio, quando cabível</li>
          <li>portabilidade, quando aplicável</li>
          <li>oposição a determinados tratamentos</li>
          <li>revogação de consentimento, quando esta for a base legal</li>
          <li>informações sobre compartilhamento de dados, quando aplicável</li>
          <li>revisão de decisões automatizadas, quando prevista em lei</li>
        </ul>
        <p class="mt-1">Solicitações poderão ser encaminhadas para:</p>
        <p class="mt-1">
          <a href="mailto:contato&#64;casatobrasil.com.br" class="text-blue-600 hover:underline">contato&#64;casatobrasil.com.br</a>
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">14. Menores de Idade</h2>
        <p class="mt-1">
          A Plataforma é destinada exclusivamente a maiores de 18 anos e não é direcionada intencionalmente a menores de idade.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">15. Alterações desta Política</h2>
        <p class="mt-1">
          Esta Política poderá ser alterada periodicamente para refletir mudanças legais, técnicas ou operacionais.
        </p>
        <p class="mt-1">
          A versão vigente estará sempre disponível na Plataforma com indicação da data da última atualização.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">16. Contato</h2>
        <p class="mt-1">
          Em caso de dúvidas, solicitações ou assuntos relacionados à privacidade e proteção de dados:
        </p>
        <p class="mt-1">
          <a href="mailto:contato&#64;casatobrasil.com.br" class="text-blue-600 hover:underline">contato&#64;casatobrasil.com.br</a>
        </p>
      </section>
    </div>
  </div>
</div>
